"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const service_codes = [121, 201, 206, 220, 221, 521, 702];
exports.default = service_codes;
